import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'planday-integration-guide',
    templateUrl: './planday-integration-guide.component.html',
    styleUrls: ['./planday-integration-guide.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'planday-integration-guide' },
    standalone: false,
})
export class PlandayIntegrationGuide {
    @Input() customerDisplayName: string;
}
